import { Directive, ElementRef, Input } from '@angular/core'
import { IdentityService } from 'main/services/identity.service'

@Directive({
  selector: '[permissionShow]',
})
export class PermissionShowDirective {
  @Input('permissionShow') permission: string

  constructor (
    private element: ElementRef<HTMLElement>,
    private identity: IdentityService,
  ) { }

  ngAfterViewInit () {
    if (!this.identity.hasPermission(this.permission)) {
      this.element.nativeElement.remove()
    }
  }
}
